/**
 * Wrap a search term for `_ilike`. LIKE treats `%`, `_` and the backslash
 * escape as wildcards, so they're escaped to match literally; an empty search
 * becomes a bare `%` so the query returns the top of the catalog unfiltered.
 * Mirrors `escapeLikePattern` in the backend's catalog search.
 */
export function toIlikePattern(search: string): string {
  const trimmed = search.trim();
  if (!trimmed) return "%";
  return `%${escapeIlike(trimmed)}%`;
}

// Matches the whole value case-insensitively, with no wildcards.
export function toExactIlikePattern(value: string): string {
  return escapeIlike(value.trim());
}

function escapeIlike(text: string): string {
  return text.replace(/[\\%_]/g, "\\$&");
}
